import { FC, Fragment } from "react";
import { Box, Divider, ListItem, ListItemAvatar, ListItemText } from "@mui/material";



interface ModuleItemProps {
    modules: any[];
    mode: 'add' | 'check'
}

const ModuleItem: FC<ModuleItemProps> = ({
    modules,
    mode
}) => {

    return (
        <Box sx={mode === 'add' ? { display: 'none' } : {}}>
            {modules?.map((module, index) => (
                <Box key={index}>
                    <ListItem disablePadding >
                        <ListItem>
                            <ListItemAvatar>
                                <img
                                    alt={module.name}
                                    style={{
                                        width: 100,
                                        height: 100,
                                        marginRight: '10px',
                                        objectFit: 'contain'
                                    }}
                                    src={URL.createObjectURL(module.image[0])}
                                />
                            </ListItemAvatar>
                            <ListItemText
                                primary={module.name}
                                secondary={
                                    <Fragment>
                                        {`${module.width}/${module.depth}/${module.height} (szer/gł/wys)`}
                                        <p style={{ fontSize: '13px', margin: 0 }}>
                                            {module.description}
                                        </p>
                                    </Fragment>
                                }
                            />
                        </ListItem>
                    </ListItem>
                    <Divider sx={{ m: 1 }} />
                </Box>
            ))}
        </Box>
    )
}

export default ModuleItem;